import React from 'react';
import styled from 'styled-components';
import { Grid, Breakpoints } from '../../../app/StyleGuide';
import { RaisedContainer } from '../../../components/Layout';
import { SmallRadioRoundedIconButton } from '../../../components/Buttons';
import { ListItemTitleContainer, ChurchImage } from '../../../components/PairingElements';
import { Org } from '../hooks/useSelectOrgForChurchCares';

const ListItemContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-gap: ${Grid._4};
  padding: ${Grid._4};
  width: 100%;

  > div:last-child {
    display: grid;
    place-content: center;
  }

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    padding-right: ${Grid._5};
  }
`;

const RaisedItemContainer = styled(RaisedContainer)`
  width: 100%;
  padding: 0;
`;

type RaisedChurchListItemProps = {
  church: Org;
  selected: boolean;
  onButtonClick: () => void;
};

export const RaisedChurchListItem = ({ church, selected, onButtonClick }: RaisedChurchListItemProps) => (
  <RaisedItemContainer>
    <ListItemContainer>
      <ChurchImage church={church} />
      <ListItemTitleContainer>
        <h4>{church.name}</h4>
      </ListItemTitleContainer>
      <div>
        <SmallRadioRoundedIconButton onClick={onButtonClick}>
          {selected ? <i className="fas fa-circle color-complete" /> : <i />}
        </SmallRadioRoundedIconButton>
      </div>
    </ListItemContainer>
  </RaisedItemContainer>
);
